import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAll(data) {
        let params = "";
        if (data) {
            Object.keys(data).forEach(key => {
                params += `${key}=${data[key]}&`;
            });
        }
        return api.get(`/api/v1/category?${params}`);
    },
    getAllList() {
        return api.post(`/api/v1/category/list`);
    },
    getById(id) {
        return api.get(`/api/v1/category/${id}`);
    },
    update(id, data) {
        return api.post(`/api/v1/category/${id}`, data);
    },
    create(data) {
        return api.post(`/api/v1/category`, data);
    },
    delete(id) {
        return api.delete(`/api/v1/category/${id}`);
    },
}